import { type PropsWithChildren } from "react"
import { Container, DropdownContent, Stack } from "@octopus-energy/coral/atoms"
import { HeaderNavMenuItem, useCoralHeader } from "@octopus-energy/coral/organisms"
import { type MenuItem } from "@/features/navigation/types/menuItem"
import { DropdownZone } from "../DropdownZone"
import { MenuDropdown } from "./MenuDropdown"
import { MenuSub } from "./MenuSub"

export function NavigationMenu({ item }: PropsWithChildren<{ item: MenuItem }>) {
    const { isMenuOpen } = useCoralHeader()
    const hasSubMenu = !!item.subMenu && item.subMenu.length > 0

    if (isMenuOpen) {
        return (
            <>
                <HeaderNavMenuItem href={item.href}>{item.label}</HeaderNavMenuItem>
                {hasSubMenu && (
                    <Stack flexDirection="column">
                        {item.subMenu?.map((subItem) => (
                            <Container
                                marginLeft="sm"
                                key={subItem.label}
                            >
                                <MenuSub.Button href={subItem.href}>{subItem.label}</MenuSub.Button>
                            </Container>
                        ))}
                    </Stack>
                )}
            </>
        )
    }

    return (
        <DropdownZone>
            <MenuDropdown.Trigger>
                <HeaderNavMenuItem href={item.href}>{item.label}</HeaderNavMenuItem>
            </MenuDropdown.Trigger>

            {hasSubMenu && (
                <DropdownContent padding="small">
                    {item.subMenu?.map((subItem) => (
                        <MenuDropdown.Button
                            href={subItem.href}
                            key={subItem.label}
                        >
                            {subItem.label}
                        </MenuDropdown.Button>
                    ))}
                </DropdownContent>
            )}
        </DropdownZone>
    )
}

NavigationMenu.Dropdown = MenuDropdown
NavigationMenu.Sub = MenuSub
